{
    "menu": [
        {
            "id": "dashboard",
            "title": "Dashboard",
            "url": "/dashboard",
            "roles": [
                "ADMINISTRATOR",
                "CONTROLLER",
                "DEVELOPER"
            ],
            "subItems": []
        },
        {
            "id": "flow_control",
            "title": "Flow",
            "url": "/flow",
            "roles": [
                "ADMINISTRATOR",
                "CONTROLLER",
                "DEVELOPER"
            ],
            "subItems": [
                {
                    "id": "component_list",
                    "title": "Finished components",
                    "url": "flow/control/component-list",
                    "roles": [
                        "ADMINISTRATOR",
                        "CONTROLLER",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "execution-fault",
                    "title": "Flow Errors",
                    "url": "flow/execution-fault",
                    "roles": [
                        "ADMINISTRATOR",
                        "CONTROLLER",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "simulation",
                    "title": "Simulations",
                    "url": "flow/simulation",
                    "roles": [
                        "ADMINISTRATOR",
                        "CONTROLLER",
                        "DEVELOPER"
                    ]
                }
            ]
        },
        {
            "id": "pricelists",
            "title": "PRICE LIST",
            "url": "/material",
            "roles": [
                "ADMINISTRATOR",
                "CONTROLLER",
                "DEVELOPER"
            ],
            "subItems": [
                {
                    "id": "submenu_material",
                    "title": "Material",
                    "url": "material",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "submenu_prod_price_list",
                    "title": "Production price list",
                    "url": "production-price-list",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "submenu_pva_manual_adjustment",
                    "title": "PVA Manual Adjustment",
                    "url": "pva-cost",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                }
            ]
        },
        {
            "id": "allocation",
            "title": "allocate",
            "url": "/allocate",
            "roles": [
                "ADMINISTRATOR",
                "CONTROLLER",
                "DEVELOPER"
            ],
            "subItems": [
                {
                    "id": "allocation_overview",
                    "title": "overview",
                    "url": "allocate",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "allocation_component",
                    "title": "component",
                    "url": "allocate/component",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "allocation_finalassembly",
                    "title": "final assembly",
                    "url": "allocate/finalassembly",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "allocation_consolidation",
                    "title": "consolidation",
                    "url": "allocate/consolidation",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                }
            ]
        },
        {
            "id": "reports",
            "title": "reports",
            "url": "/reports",
            "roles": [
                "ADMINISTRATOR",
                "CONTROLLER",
                "DEVELOPER"
            ],
            "subItems": [
                {
                    "id": "reports_cpa",
                    "title": "CPA Report",
                    "url": "reports/cpa",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "reports_replacement_components",
                    "title": "Replacement Components List",
                    "url": "reports/replacementComponents",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "missing_sim_materials",
                    "title": "Missing SIM Materials",
                    "url": "reports/missingSIMMaterials",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "reports_removed_invoicedates",
                    "title": "Removed InvoiceDates List",
                    "url": "reports/removedInvoicedate",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "missing_side_members",
                    "title": "Missing Side Members",
                    "url": "reports/missingSideMembers",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "multi_invoice",
                    "title": "Invoice Details",
                    "url": "reports/multiInvoice",
                    "roles": [
                        "ADMINISTRATOR",
                        "DEVELOPER"
                    ]
                }
            ]
        },
        {
            "id": "administraion",
            "title": "administration",
            "url": "/admin",
            "roles": [
                "ADMINISTRATOR"
            ],
            "subItems": [
                {
                    "id": "admin_currency_adjustment_code",
                    "title": "Currency Adjustment Code",
                    "url": "admin/currency-adjustment-code",
                    "roles": [
                        "ADMINISTRATOR",
                        "CONTROLLER",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "admin_currency_adjustment_condition",
                    "title": "Currency Adjustment Conditions",
                    "url": "admin/currency-adjustment-condition",
                    "roles": [
                        "ADMINISTRATOR",
                        "CONTROLLER",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "admin_manual_invoicing",
                    "title": "Manual Invoicing",
                    "url": "admin/manual-invoicing",
                    "roles": [
                        "ADMINISTRATOR",
                        "CONTROLLER",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "admin_markup_condition_material",
                    "title": "Markup Condition Material",
                    "url": "admin/markup-condition-material",
                    "roles": [
                        "ADMINISTRATOR",
                        "CONTROLLER",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "admin_markup_percentage",
                    "title": "Markup Percentage",
                    "url": "admin/markup-percentage",
                    "roles": [
                        "ADMINISTRATOR",
                        "CONTROLLER",
                        "DEVELOPER"
                    ]
                },
                {
                    "id": "admin_product_class_component_unit",
                    "title": "Product Class Component Unit",
                    "url": "admin/product-class-component-unit",
                    "roles": [
                        "ADMINISTRATOR",
                        "CONTROLLER",
                        "DEVELOPER"
                    ]
                }
            ]
        }
    ],
    "loadingItems": []
}